import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
    Box,
    Card,
    Grid,
    TextField,
    makeStyles,
    Container,
    Button,
    CardContent,
    Divider,
    InputLabel,
    CardHeader,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from 'yup';
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import { useAlert } from 'react-alert';
import xlsx from 'json-as-xlsx';
import ReactToPrint from 'react-to-print';
import CreatePDF from './CreatePDF';
import _ from 'lodash';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {
    DatePicker,
} from '@material-ui/pickers';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    colorCancel: {
        backgroundColor: 'red'
    },
    colorRecord: {
        backgroundColor: 'green'
    }
}));

const screenCode = 'BANKRECONCILIATIONHISTORYREPORT';

export default function BankReconciliationHistoryReport(props) {
    const [title, setTitle] = useState('Bank Reconciliation History Report');
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [GroupList, setGroupList] = useState([]);
    const [FactoryList, setFactoryList] = useState([]);
    const [bankReconciliationDetails, setBankReconciliationDetails] = useState({
        groupID: 0,
        factoryID: 0,
        tranLedgerAccountID: 0,
        year: new Date().getUTCFullYear().toString(),
        month: (new Date().getUTCMonth() + 1).toString().padStart(2, '0'),
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const navigate = useNavigate();
    const alert = useAlert();
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const componentRef = useRef();
    const [reconciliationRegisterdData, setReconciliationRegisterdData] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [isReportAvailabale, setIsReportAvailable] = useState(false);
    const [banksAuto, setBanksAuto] = useState();
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        month: '',
        year: '',
        groupName: '',
        factoryName: '',
        accountType: ''
    });

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const open = Boolean(anchorEl);

    useEffect(() => {
        getGroupsForDropdown();
        getPermission();
    }, []);

    useEffect(() => {
        getfactoriesForDropDown();
    }, [bankReconciliationDetails.groupID]);

    useEffect(() => {
        setBankReconciliationDetails({
            ...bankReconciliationDetails,
            tranLedgerAccountID: 0,
            year: new Date().getUTCFullYear().toString(),
            month: (new Date().getUTCMonth() + 1).toString().padStart(2, '0'),
        });
    }, [bankReconciliationDetails.factoryID, bankReconciliationDetails.groupID]);

    useEffect(() => {
        trackPromise(getTranLedgerListForDropdownAuto()
        );
    }, [bankReconciliationDetails.factoryID]);

    useEffect(() => {
        setReconciliationRegisterdData([]);
    }, [bankReconciliationDetails.groupID, bankReconciliationDetails.factoryID, bankReconciliationDetails.tranLedgerAccountID, bankReconciliationDetails.year, bankReconciliationDetails.month]);

    async function getPermission() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(
            p => p.permissionCode == 'VIEWBANKRECONCILIATIONHISTORYREPORT'
        );

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(
            p => p.permissionCode === 'GROUPDROPDOWN'
        );
        var isFactoryFilterEnabled = permissions.find(
            p => p.permissionCode === 'FACTORYDROPDOWN'
        );

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
        });

        setBankReconciliationDetails({
            ...bankReconciliationDetails,
            groupID: parseInt(tokenService.getGroupIDFromToken()),
            factoryID: parseInt(tokenService.getFactoryIDFromToken())
        });
    }

    async function getGroupsForDropdown() {
        const groups = await services.getGroupsForDropdown();
        setGroupList(groups);
    }

    async function getfactoriesForDropDown() {
        const factory = await services.getfactoriesForDropDown(
            bankReconciliationDetails.groupID
        );
        setFactoryList(factory);
    }

    async function GetDetails() {
        let model = {
            groupID: parseInt(bankReconciliationDetails.groupID),
            factoryID: parseInt(bankReconciliationDetails.factoryID),
            ledgerAccountID: parseInt(bankReconciliationDetails.tranLedgerAccountID),
            year: bankReconciliationDetails.year.toString(),
            month: bankReconciliationDetails.month.toString(),
        };
        const bankData = await services.GetBankReconciliationData(model);

        if (bankData.statusCode == "Success" && bankData.data != null) {
            setReconciliationRegisterdData(bankData.data);
            setIsReportAvailable(true);
        }
        else {
            setReconciliationRegisterdData([])
            setIsReportAvailable(false);
            alert.error(bankData.message);
        }
    }

    async function getTranLedgerListForDropdownAuto() {
        const banksResults = await services.getTranLedgerListForDropdownAuto(bankReconciliationDetails.factoryID);
        setBanksAuto(banksResults);
    }

    function handleSearchDropdownChangeFieldsBankAccounts(data, e) {
        if (data === undefined || data === null) {
            setBankReconciliationDetails({
                ...bankReconciliationDetails,
                tranLedgerAccountID: '0'
            });
            return;
        } else {
            var valueV = data["ledgerAccountID"];
            setBankReconciliationDetails({
                ...bankReconciliationDetails,
                tranLedgerAccountID: valueV
            });
        }
        setReconciliationRegisterdData([]);
        setIsReportAvailable(false);
    }

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleLimitChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const getStatusText = (reconsilationStatus) => {
        if (reconsilationStatus === 3) {
            return 'Approved';
        } else if (reconsilationStatus === 2) {
            return 'Pending Approval';
        }
        return '-';
    };

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    function handleChange(e) {
        const { name, value } = e.target;

        setBankReconciliationDetails({
            ...bankReconciliationDetails,
            [name]: value
        });

        if (name === "groupID") {
            const groupName = GroupList[value] || "";
            setSelectedSearchValues({
                ...selectedSearchValues,
                groupName
            });
        } else if (name === "factoryID") {
            const factoryName = FactoryList[value] || "";
            setSelectedSearchValues({
                ...selectedSearchValues,
                factoryName
            });
        } else {
            setSelectedSearchValues({
                ...selectedSearchValues,
                [name]: value
            });
        }

        setReconciliationRegisterdData([]);
        setIsReportAvailable(false);
    }

    function handleDateChange(date) {
        let monthNames = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];

        var month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
        var year = date.getUTCFullYear();
        let monthName = monthNames[parseInt(month) - 1];

        setSelectedSearchValues({
            ...selectedSearchValues,
            month,
            year,
            monthName
        });

        setBankReconciliationDetails({
            ...bankReconciliationDetails,
            month: month.toString(),
            year: year.toString()
        });

        setSelectedDate(date);
        setReconciliationRegisterdData([]);
        setIsReportAvailable(false);
    }


    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
            </Grid>
        );
    }

    async function createFile() {
        var file = await createDataForExcel(reconciliationRegisterdData);

        var settings = {
            sheetName: 'Bank Reconciliation History Report',
            fileName:
                'Bank Reconciliation History Report - ' +
                selectedSearchValues.groupName + ' ' +
                selectedSearchValues.factoryName + ' ' +
                bankReconciliationDetails.year + '-' +
                bankReconciliationDetails.month,
            writeOptions: {}
        };

        let keys = Object.keys(file[0]);
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem });
        });

        let dataA = [
            {
                sheet: 'Manufacturing Details Report',
                columns: tempcsvHeaders,
                content: file
            }
        ];
        xlsx(dataA, settings);
    }


    async function createDataForExcel(array) {
        var res = [];
        let totalCredit = 0;
        let totalDebit = 0;
        if (array != null) {
            array.map(x => {
                totalCredit += x.credit;
                totalDebit += x.debit;
                var vr = {
                    'Date': x.date.split('T')[0],
                    'Voucher Number': x.referenceNumber,
                    'Description': x.description,
                    'Cheque Number': x.chequeNumber,
                    'Credit': x.credit,
                    'Debit': x.debit,
                    'Due Date': x.dueDate ? x.dueDate.split('T')[0] : '',
                    'Realized Date': x.realizedDate ? x.realizedDate.split('T')[0] : '',
                    'Status': getStatusText(x.reconsilationStatus)
                };
                res.push(vr);
            });
        }
        var total = {
            'Date': 'Total',
            'Credit': totalCredit,
            'Debit': totalDebit
        }
        res.push(total);
        var vr0 = { '': '' };
        res.push(vr0);

        var vr={
            'Date': 'Group: ' + selectedSearchValues.groupName,
            'Voucher Number': 'Factory: ' + selectedSearchValues.factoryName,
        }
        res.push(vr);
        var vr = {
            'Date': 'Account: ' + (banksAuto?.find(option => option.ledgerAccountID === bankReconciliationDetails.tranLedgerAccountID)?.ledgerAccountName || ''),
            'Voucher Number': 'Month: ' + bankReconciliationDetails.year + '-' + bankReconciliationDetails.month,
        }
        res.push(vr);
        return res;
    }

    return (
        <Fragment>
            <Page className={classes.root} title={title}>
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            groupID: bankReconciliationDetails.groupID,
                            factoryID: bankReconciliationDetails.factoryID,
                            tranLedgerAccountID: bankReconciliationDetails.tranLedgerAccountID,
                        }}
                        validationSchema={Yup.object().shape({
                            groupID: Yup.number()
                                .required('Group is required')
                                .min('1', 'Group is required'),
                            factoryID: Yup.number()
                                .required('Factory is required')
                                .min('1', 'Factory is required'),
                            tranLedgerAccountID: Yup.number().
                                required('Ledger Account is required')
                                .min('1', 'Ledger Account is required'),
                        })}
                        onSubmit={() => trackPromise(GetDetails())}
                        enableReinitialize
                    >
                        {({ errors, handleBlur, handleSubmit, touched }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Card>
                                        <CardHeader title={cardTitle(title)} />
                                        <PerfectScrollbar>
                                            <Divider />
                                            <CardContent>
                                                <Grid container spacing={3}>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="groupID">
                                                            Group *
                                                        </InputLabel>
                                                        <TextField
                                                            select
                                                            error={Boolean(touched.groupID && errors.groupID)}
                                                            fullWidth
                                                            helperText={touched.groupID && errors.groupID}
                                                            name="groupID"
                                                            onBlur={handleBlur}
                                                            onChange={e => handleChange(e)}
                                                            value={bankReconciliationDetails.groupID}
                                                            variant="outlined"
                                                            id="groupID"
                                                            size='small'
                                                            disabled={!permissionList.isGroupFilterEnabled}
                                                        >
                                                            <MenuItem value="0">--Select Group--</MenuItem>
                                                            {generateDropDownMenu(GroupList)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="factoryID">
                                                            Factory *
                                                        </InputLabel>
                                                        <TextField
                                                            select
                                                            error={Boolean(
                                                                touched.factoryID && errors.factoryID
                                                            )}
                                                            fullWidth
                                                            helperText={touched.factoryID && errors.factoryID}
                                                            name="factoryID"
                                                            onBlur={handleBlur}
                                                            onChange={e => handleChange(e)}
                                                            value={bankReconciliationDetails.factoryID}
                                                            variant="outlined"
                                                            id="factoryID"
                                                            size='small'
                                                            disabled={!permissionList.isFactoryFilterEnabled}
                                                        >
                                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                                            {generateDropDownMenu(FactoryList)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <DatePicker
                                                                autoOk
                                                                variant="inline"
                                                                openTo="month"
                                                                views={["year", "month"]}
                                                                label="Year and Month *"
                                                                helperText="Select applicable month"
                                                                value={selectedDate}
                                                                disableFuture={true}
                                                                onChange={date => handleDateChange(date)}
                                                                size="small"
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </Grid>
                                                    <Grid item md={4} xs={12} style={{ marginTop: '-1%' }}>
                                                        <InputLabel shrink id="tranLedgerAccountID">
                                                            Bank Account *
                                                        </InputLabel>
                                                        <Autocomplete
                                                            id="tranLedgerAccountID"
                                                            options={banksAuto || []}
                                                            getOptionLabel={(option) => option?.ledgerAccountName
                                                                || "Unnamed Bank"}
                                                            onChange={(e, value) => handleSearchDropdownChangeFieldsBankAccounts(value, e)}
                                                            value={
                                                                banksAuto?.find(
                                                                    (option) => option.ledgerAccountID === bankReconciliationDetails.tranLedgerAccountID
                                                                ) || null
                                                            }
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    variant="outlined"
                                                                    name="tranLedgerAccountID"
                                                                    fullWidth
                                                                    size="small"
                                                                    placeholder="--Select Account Type Name --"
                                                                    onBlur={handleBlur}
                                                                    error={Boolean(touched.tranLedgerAccountID && errors.tranLedgerAccountID)}
                                                                    helperText={touched.tranLedgerAccountID && errors.tranLedgerAccountID}
                                                                />
                                                            )}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <Grid container spacing={3}>
                                                </Grid>
                                                <Box display="flex" flexDirection="row-reverse" p={2}>
                                                    <Button
                                                        color="primary"
                                                        type="submit"
                                                        variant="contained"
                                                        size='small'
                                                    >
                                                        Search
                                                    </Button>
                                                </Box>
                                            </CardContent>

                                            {reconciliationRegisterdData.length > 0 ? (
                                                <Box minWidth={1050}>
                                                    <TableContainer>
                                                        <Table aria-label="bank reconciliation table">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell align="left">Date</TableCell>
                                                                    <TableCell align="left">Voucher Number</TableCell>
                                                                    <TableCell align="left">Description</TableCell>
                                                                    <TableCell align="left">Cheque Number</TableCell>
                                                                    <TableCell align="right">Credit</TableCell>
                                                                    <TableCell align="right">Debit</TableCell>
                                                                    <TableCell align="left">Due Date</TableCell>
                                                                    <TableCell align="left">Realized Date</TableCell>
                                                                    <TableCell align="left">Status</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {reconciliationRegisterdData
                                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                    .map((data, index) => (
                                                                        <TableRow key={index}>
                                                                            <TableCell align="left">
                                                                                {data.date && moment(data.date).isValid() && !moment(data.date).isSame('0001-01-01')
                                                                                    ? moment(data.date).format('DD/MM/YYYY')
                                                                                    : '-'}
                                                                            </TableCell>
                                                                            <TableCell align="left">{data.referenceNumber || '-'}</TableCell>
                                                                            <TableCell align="left">{data.description || '-'}</TableCell>
                                                                            <TableCell align="left">{data.chequeNumber || '-'}</TableCell>
                                                                            <TableCell align="right">
                                                                                {data.credit ? data.credit.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                                                            </TableCell>
                                                                            <TableCell align="right">
                                                                                {data.debit ? data.debit.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                                                            </TableCell>
                                                                            <TableCell align="left">
                                                                                {data.dueDate && moment(data.dueDate).isValid() && !moment(data.dueDate).isSame('0001-01-01')
                                                                                    ? moment(data.dueDate).format('DD/MM/YYYY')
                                                                                    : '-'}
                                                                            </TableCell>
                                                                            <TableCell align="left">
                                                                                {data.realizedDate && moment(data.realizedDate).isValid() && !moment(data.realizedDate).isSame('0001-01-01')
                                                                                    ? moment(data.realizedDate).format('DD/MM/YYYY')
                                                                                    : '-'}
                                                                            </TableCell>
                                                                            <TableCell align="left">{getStatusText(data.reconsilationStatus)}</TableCell>
                                                                        </TableRow>
                                                                    ))}
                                                                <TableRow style={{  fontWeight: 'bold' }}>
                                                                    <TableCell align="left" colSpan={4} style={{ fontWeight: 'bold' }}>TOTAL</TableCell>
                                                                    <TableCell align="right" style={{ fontWeight: 'bold' }}>
                                                                        {reconciliationRegisterdData
                                                                            .reduce((sum, data) => sum + (data.credit || 0), 0)
                                                                            .toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </TableCell>
                                                                    <TableCell align="right" style={{ fontWeight: 'bold' }}>
                                                                        {reconciliationRegisterdData
                                                                            .reduce((sum, data) => sum + (data.debit || 0), 0)
                                                                            .toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </TableCell>
                                                                    <TableCell colSpan={3}></TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        </Table>
                                                        <TablePagination
                                                            component="div"
                                                            count={reconciliationRegisterdData.length}
                                                            onChangePage={handlePageChange}
                                                            onChangeRowsPerPage={handleLimitChange}
                                                            page={page}
                                                            rowsPerPage={rowsPerPage}
                                                            rowsPerPageOptions={[5, 10, 25]}
                                                        />
                                                    </TableContainer>
                                                </Box>
                                            ) : null}

                                            {isReportAvailabale ? (
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <Button
                                                        color="primary"
                                                        id="btnRecord"
                                                        type="button"
                                                        variant="contained"
                                                        style={{ marginRight: '1rem' }}
                                                        className={classes.colorRecord}
                                                        onClick={() => createFile()}
                                                        size='small'
                                                    >
                                                        EXCEL
                                                    </Button>
                                                    <ReactToPrint
                                                        documentTitle={'Bank Reconciliation History Report - ' +
                                                            selectedSearchValues.groupName + ' ' +
                                                            selectedSearchValues.factoryName + ' ' +
                                                            bankReconciliationDetails.year + '-' +
                                                            bankReconciliationDetails.month}
                                                        trigger={() => (
                                                            <Button
                                                                color="primary"
                                                                id="btnRecord"
                                                                type="button"
                                                                variant="contained"
                                                                style={{ marginRight: '1rem' }}
                                                                className={classes.colorCancel}
                                                                size='small'
                                                            >
                                                                PDF
                                                            </Button>
                                                        )}
                                                        content={() => componentRef.current}
                                                        pageStyle="@page { size: A4; margin: 0.5in; } @media print { body { -webkit-print-color-adjust: exact; background-color: white !important; } }"
                                                    />
                                                    <div hidden={true}>
                                                        <CreatePDF
                                                            ref={componentRef}
                                                            reconciliationRegisterdData={reconciliationRegisterdData}
                                                            searchData={selectedSearchValues}
                                                            bankReconciliationDetails={bankReconciliationDetails}
                                                            bankData={banksAuto?.find(option => option.ledgerAccountID === bankReconciliationDetails.tranLedgerAccountID) || null}
                                                        />
                                                    </div>
                                                </Box>
                                            ) : null}
                                        </PerfectScrollbar>
                                    </Card>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Page>
        </Fragment>
    );
}
